import React from 'react';
import {
  Home, MapPin, Shield, Users, ShoppingBag, LogOut,
  ChevronRight, Star
} from 'lucide-react';

const navItems = [
  { id: 'beranda', label: 'Beranda', icon: Home, sublabel: 'Marketplace' },
  { id: 'tracker', label: 'Journey Tracker', icon: MapPin, sublabel: 'Status Perjalanan' },
  { id: 'escrow', label: 'Smart Escrow', icon: Shield, sublabel: 'Keamanan Dana' },
  { id: 'komunitas', label: 'Komunitas', icon: Users, sublabel: 'Forum Jamaah' },
  { id: 'toko', label: 'Toko', icon: ShoppingBag, sublabel: 'Perlengkapan' },
];

export default function Sidebar({ currentPage, setCurrentPage, sidebarOpen, user, onLogout }) {
  return (
    <aside
      data-testid="dashboard-sidebar"
      className={`
        fixed top-0 left-0 h-full w-60 z-40 flex flex-col
        dark:bg-[#1A1A24] bg-white
        dark:border-r dark:border-[#2D3748] border-r border-[#E2E8F0]
        transition-transform duration-300 ease-in-out
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}
    >
      {/* Logo */}
      <div className="px-6 py-5 border-b dark:border-[#2D3748] border-[#E2E8F0]">
        <span className="text-xl font-black tracking-tight">
          <span className="text-[#00C9B1]">UMROH</span>
          <span className="dark:text-white text-[#1A202C]">LOKA</span>
        </span>
        <p className="text-xs dark:text-gray-500 text-gray-400 mt-0.5">Super App Ekosistem Umrah</p>
      </div>

      {/* Nav */}
      <nav className="flex-1 py-4 overflow-y-auto">
        <div className="px-3 space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPage === item.id;
            return (
              <button
                key={item.id}
                data-testid={`sidebar-nav-${item.id}`}
                onClick={() => setCurrentPage(item.id)}
                className={`
                  w-full flex items-center gap-3 px-3 py-3 rounded-xl text-left transition-all duration-200
                  ${isActive
                    ? 'bg-[#00C9B1]/10 text-[#00C9B1] border border-[#00C9B1]/20'
                    : 'dark:text-gray-400 text-gray-500 dark:hover:text-white hover:text-[#1A202C] dark:hover:bg-white/5 hover:bg-gray-100 border border-transparent'
                  }
                `}
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${isActive ? 'bg-[#00C9B1]/15' : 'dark:bg-white/5 bg-gray-100'}`}>
                  <Icon
                    size={16}
                    strokeWidth={1.5}
                    className={isActive ? 'text-[#00C9B1]' : 'dark:text-gray-400 text-gray-500'}
                  />
                </div>
                <div className="min-w-0">
                  <div className={`text-sm font-semibold truncate ${isActive ? 'text-[#00C9B1]' : 'dark:text-gray-300 text-gray-700'}`}>
                    {item.label}
                  </div>
                  <div className="text-xs dark:text-gray-600 text-gray-400 truncate">{item.sublabel}</div>
                </div>
                {isActive && <ChevronRight size={14} className="ml-auto text-[#00C9B1] flex-shrink-0" />}
              </button>
            );
          })}
        </div>
      </nav>

      {/* Active Package */}
      <div className="px-4 py-3 mx-3 mb-3 rounded-2xl bg-gradient-to-br from-[#00C9B1]/10 to-[#F5A623]/5 border border-[#00C9B1]/15">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-1.5 h-1.5 rounded-full bg-[#00C9B1] animate-pulse" />
          <span className="text-[10px] font-semibold text-[#00C9B1] uppercase tracking-wider">Paket Aktif</span>
        </div>
        <p className="text-xs font-medium dark:text-white text-[#1A202C] line-clamp-2">Paket Gold Ramadan 2026</p>
        <p className="text-[10px] dark:text-gray-500 text-gray-400 mt-0.5">Berangkat 15 Mar 2026</p>
      </div>

      {/* User + Logout */}
      <div className="p-4 border-t dark:border-[#2D3748] border-[#E2E8F0]">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#00C9B1] to-[#00A896] flex items-center justify-center text-[#0E0E12] font-bold text-sm flex-shrink-0">
            {user?.name?.split(' ').map(n => n[0]).join('').slice(0, 2) || 'BS'}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold dark:text-white text-[#1A202C] truncate">{user?.name || 'Jamaah'}</p>
            <p className="text-xs dark:text-gray-500 text-gray-400 truncate">{user?.email || ''}</p>
          </div>
          <button
            data-testid="sidebar-logout-btn"
            onClick={onLogout}
            className="p-2 dark:text-gray-500 text-gray-400 dark:hover:text-red-400 hover:text-red-400 transition-colors rounded-lg dark:hover:bg-red-400/10 hover:bg-red-50"
            title="Keluar"
          >
            <LogOut size={16} />
          </button>
        </div>
      </div>
    </aside>
  );
}
